var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              [
                _vm.activateSpinner
                  ? _c("spinner")
                  : _vm.listItems.length > 0
                  ? _c("b-table", {
                      staticClass: "table-striped table-hover",
                      attrs: {
                        items: _vm.listItems,
                        fields: _vm.fields,
                        "sort-by": _vm.sortBy,
                        fixed: "",
                        hover: "",
                        selectable: _vm.listItems.length > 0,
                        "empty-text": _vm.$t("common.security.no_result"),
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "row-selected": _vm.onRowSelected,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(name)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(type)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(active)",
                          fn: function (data) {
                            return [
                              data.value == 1
                                ? _c("i", {
                                    staticClass:
                                      "fa-regular fa-circle-check cursor color-var-actionButtonColorBlue",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              data.value == 2
                                ? _c("i", {
                                    staticClass:
                                      "fa-regular fa-circle-xmark cursor text-danger",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              data.value == 3
                                ? _c("i", {
                                    staticClass:
                                      "fa-solid fa-triangle-exclamation cursor text-warning",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              data.value == 4
                                ? _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12px",
                                        height: "14px",
                                        viewBox: "0 0 32.07053 40.365376",
                                        version: "1.1",
                                        id: "svg1",
                                        "xml:space": "preserve",
                                        "xmlns:inkscape":
                                          "http://www.inkscape.org/namespaces/inkscape",
                                        "xmlns:sodipodi":
                                          "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:svg":
                                          "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("sodipodi:namedview", {
                                        attrs: {
                                          id: "namedview1",
                                          pagecolor: "#ffffff",
                                          bordercolor: "#000000",
                                          borderopacity: "0.25",
                                          "inkscape:showpageshadow": "2",
                                          "inkscape:pageopacity": "0.0",
                                          "inkscape:pagecheckerboard": "0",
                                          "inkscape:deskcolor": "#d1d1d1",
                                          "inkscape:document-units": "mm",
                                        },
                                      }),
                                      _c("defs", { attrs: { id: "defs1" } }),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            "inkscape:label": "Calque 1",
                                            "inkscape:groupmode": "layer",
                                            id: "layer1",
                                            transform:
                                              "translate(-124.57853,-104.79531)",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            staticStyle: { fill: "#6c757d" },
                                            attrs: {
                                              d: "m 127.25978,145.00538 c -0.45406,-0.1773 -0.85947,-0.54183 -1.09536,-0.9849 -0.22163,-0.41631 -0.23972,-1.36693 -0.0338,-1.77485 0.0767,-0.15185 0.9153,-1.34099 1.86363,-2.64255 l 1.72424,-2.36646 -0.68297,-0.7147 c -5.06603,-5.30141 -5.90765,-13.36707 -2.03987,-19.54895 3.16887,-5.06481 8.94909,-8.01807 14.77198,-7.54738 2.08988,0.16894 3.9012,0.64805 5.70841,1.50992 0.53652,0.25587 1.00598,0.44638 1.04324,0.42335 0.0373,-0.023 0.87305,-1.1496 1.85729,-2.50349 2.64487,-3.63817 2.57373,-3.54875 3.01362,-3.78816 0.74696,-0.40655 1.54987,-0.35553 2.23253,0.14186 0.74545,0.54314 1.03565,1.70604 0.62321,2.49732 -0.0958,0.18377 -1.10499,1.61421 -2.24267,3.17876 -1.13769,1.56456 -2.09752,2.89263 -2.13297,2.95129 -0.0446,0.0737 0.0931,0.26844 0.44615,0.63105 2.17767,2.23653 3.71485,5.42737 4.20476,8.72814 0.17121,1.15347 0.17041,3.3406 -0.002,4.49627 -0.51847,3.48277 -2.07875,6.57754 -4.5744,9.07319 -3.04491,3.04491 -7.00343,4.69337 -11.26488,4.69107 -2.43943,-0.001 -4.45175,-0.42422 -6.6431,-1.39611 -0.43385,-0.19242 -0.82798,-0.36688 -0.87584,-0.38769 -0.0479,-0.0208 -0.87677,1.04701 -1.84201,2.37292 -0.96523,1.32591 -1.88449,2.51787 -2.04278,2.64881 -0.32042,0.26503 -0.91849,0.47211 -1.34732,0.46648 -0.15482,-0.002 -0.45609,-0.0719 -0.66949,-0.15519 z m 15.01049,-7.77316 c 7.10553,-1.04017 11.66693,-7.88525 9.8793,-14.82541 -0.42902,-1.6656 -1.38199,-3.47248 -2.51282,-4.76443 l -0.30376,-0.34704 -6.82424,9.37903 c -3.75334,5.15846 -6.84862,9.41974 -6.87842,9.4695 -0.12765,0.21319 2.30165,0.97629 3.57366,1.12257 0.96094,0.11051 2.16975,0.097 3.06628,-0.0342 z m -3.14023,-12.92436 c 6.31248,-8.67496 6.87048,-9.46657 6.74007,-9.56193 -0.23265,-0.17011 -1.22186,-0.55971 -1.97611,-0.77828 -2.33429,-0.67646 -5.00232,-0.58553 -7.3168,0.24934 -4.7224,1.70347 -7.86783,6.19461 -7.86282,11.22678 0.003,2.95875 0.99816,5.58868 2.97886,7.87184 0.23685,0.27301 0.45851,0.48599 0.49259,0.47329 0.0341,-0.0127 3.15897,-4.27916 6.94421,-9.48104 z",
                                              id: "path1",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    })
                  : _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("span", { staticClass: "noResult" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.no_result")) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }